module.exports = __webpack_public_path__ + "img/test.f9ae2831.jpg";